import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {Route, Switch} from 'react-router-dom';
import CallForPapersForm from './CallForPapersForm';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import I18nTemplateContent from '../i18n/I18nTemplateContent';
import Col from 'react-bootstrap/Col';
import CallForPapersReviewForm from "./CallForPapersReviewForm";
import MyAreaButton from "./MyArea/MyAreaButton";

const CallForPapers = ({callForPapers, roles}) => {
    const intl = useIntl();

    return (
        <Switch>
            {/* Formular - create */}
            <Route path="/:slug" exact={true}>
                <CallForPapersForm intl={intl}
                                   callForPapers={callForPapers}
                                   roles={roles}
                />
            </Route>

            {/* Formular - edit */}
            <Route path="/:slug/edit/:submissionId" exact>
                <CallForPapersForm intl={intl}
                                   callForPapers={callForPapers}
                                   roles={roles}
                />
            </Route>

            {/* Formular - review - edit */}
            <Route path="/:slug/review/:submissionId/:reviewId" exact>
                <CallForPapersReviewForm intl={intl}
                                         callForPapers={callForPapers}
                                         roles={roles}
                />
            </Route>

            {/* Einreichungsbestätigung */}
            <Route path="/:slug/result" exact>
                <Container data-testid="submissionResultPageContainer">
                    <Row>
                        <I18nTemplateContent as={Col}
                                             templateContainer={callForPapers.templateContainer}
                                             templateName="frontendSubmissionResultBody"
                        />
                        <MyAreaButton/>
                    </Row>
                </Container>
            </Route>

            {/* FIXME sollte sich die LM jemals dazu entscheiden, hier so wie oben das konfigurierte Template nutzen */}
            {/* Bewertungsbestätigung */}
            <Route path="/:slug/reviewresult" exact>
                <Container data-testid="submissionReviewResultPageContainer">
                    <Row>
                        <Col className="reviewResult">
                            <FormattedMessage id="submission.review.result"/>
                            <MyAreaButton/>
                        </Col>
                    </Row>
                </Container>
            </Route>

            {/* Datenschutzinformationen */}
            <Route path="/:slug/legal" exact>
                <Container data-testid="legalPageContainer">
                    <Row>
                        <I18nTemplateContent as={Col}
                                             templateContainer={callForPapers.templateContainer}
                                             templateName="frontendLegalPage"
                        />
                    </Row>
                </Container>
            </Route>

            {/* Kontaktinformationen */}
            <Route path="/:slug/contact" exact>
                <Container data-testid="contactPageContainer">
                    <Row>
                        <I18nTemplateContent as={Col}
                                             templateContainer={callForPapers.templateContainer}
                                             templateName="frontendContactPage"
                        />
                    </Row>
                </Container>
            </Route>
        </Switch>
    );

};

export default CallForPapers;
